/**************************************************
 * Nombre:       Formulario_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid, IconButton, Typography} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {AccountCircle, Apartment, Flag, HomeWork, Mail, PhoneAndroid, WhatsApp} from "@mui/icons-material";

import {ESTADOSEMPRESARIAS, ESTADOSPOTENCIALES} from "../../Constantes";
import {useEffect, useState} from "react";
import IngresoSelectFuncion from "../../Modulo_formularios/Componentes/IngresoSelectFuncion";
import {enviarLinkRegistro} from "../../Utilidades/enviarLinkRegistro";
import {irWhatsApp} from "../../Utilidades/irWhatsApp";
import {theme} from "../../Tema";


const Formulario_Empresaria_Detalles = ({...props}) => {
    const [estado, setEstado] = useState('')
    const [numero, setNumero] = useState('')
    const [pais,setPais] = useState('')
    const enviarLink = () => {

        let entidad = props.props.getValues()
        enviarLinkRegistro(entidad)

    }



    useEffect(() => {

        let num = props.props.watch('celular')
        let pais_ = props.props.watch('pais')
        setNumero(num)
        setPais(pais_)

    }, [props.props.watch('celular')]);
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
                spacing={2}
                sx={{p: 1}}
            >

                <Grid item container lg={6} sm={6} xs={6} sx={{justifyContent: 'center'}}>
                    <IngresoSelectFuncion Icono={Flag} nombre={'Estado'} dato={'estado'}  {...props}
                                          opciones={ESTADOSEMPRESARIAS} setDato={setEstado}
                    />
                </Grid>


                <Grid item container lg={12} sm={12} xs={12} sx={{justifyContent: 'center'}}>
                    <IngresoTexto Icono={AccountCircle} nombre={'Nombre'} dato={'nombre'}  {...props}


                    />
                </Grid>

                <Grid item container lg={7} sm={7} xs={7} sx={{justifyContent: 'center'}}>
                    <IngresoTexto Icono={PhoneAndroid} nombre={'Celular'} dato={'celular'}  {...props}

                    />
                </Grid>



                <Grid item container lg={5} sm={5} xs={6} sx={{justifyContent: 'flex-end'}}>
                    {estado === 'Nueva' ?
                        <Button
                            onClick={() => enviarLink()}
                        >
                            Link de registro
                        </Button>

                        :
                        <Grid item container lg={2} sm={2} xs={3} sx={{justifyContent: 'flex-end'}}>
                            <IconButton
                                onClick={() => irWhatsApp({num: numero, pais: pais})}
                                sx={{backgroundColor: theme.palette.primary.main}}>
                                <WhatsApp sx={{fill: '#fff'}}/>
                            </IconButton>
                        </Grid>

                    }
                </Grid>


                <Grid item container lg={12} sm={12} xs={12} sx={{justifyContent: 'center'}}>
                    <IngresoTexto Icono={Mail} nombre={'Correo'} dato={'correo'}  {...props}
                                  editable={false}

                    />
                </Grid>


                <Grid item container lg={6} sm={6} xs={6} sx={{justifyContent: 'center'}}>
                    <IngresoTexto Icono={Apartment} nombre={'Pais'} dato={'pais'}  {...props}
                                  editable={false}
                    />
                </Grid>

                <Grid item container lg={6} sm={6} xs={6} sx={{justifyContent: 'center'}}>
                    <IngresoTexto Icono={HomeWork} nombre={'Ciudad'} dato={'ciudad'}  {...props}
                                  editable={false}
                    />
                </Grid>


                <Grid item container lg={12} sm={12} xs={12} sx={{justifyContent: 'flex-start'}}>
                    <IngresoTexto nombre={'Notas'} dato={'notas'} lineas={6}  {...props}
                    />
                </Grid>


            </Grid>
        </form>

    )

}
export default Formulario_Empresaria_Detalles